/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * eCFR SDK
 * TypeScript SDK and Model Context Protocol server for the Electronic Code of Federal Regulations (eCFR) API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiSearchV1ResultsPaginateBy = typeof GetApiSearchV1ResultsPaginateBy[keyof typeof GetApiSearchV1ResultsPaginateBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiSearchV1ResultsPaginateBy = {
  date: 'date',
  results: 'results',
} as const;
